module.exports = __webpack_public_path__ + "/images/ico-ellipsis.d459cca.svg";